import React from 'react';
import AdminMenuGrid from '../components/AdminMenuGrid';
import {
  Table2, History, FileBarChart, Key, Clock,
  GitMerge, Settings2, Hash, Map, Globe, Webhook,
  ClipboardList, Shield, ShieldAlert, CalendarClock, Settings, Target, TrendingUp, Zap, HeartHandshake,
  Smartphone
} from 'lucide-react';

const SystemHubPage = () => {
  const items = [
    { label: 'System Settings', icon: Settings, path: '/dashboard/admin/system/settings', id: 'system-settings' },
    { label: 'Credit Score Config', icon: Target, path: '/dashboard/admin/system/credit-score-config', id: 'credit-score-config' },
    { label: 'External Services', icon: Globe, path: '/dashboard/admin/system/external-services', id: 'external-services' },
    { label: 'Rate Management', icon: TrendingUp, path: '/dashboard/admin/system/rate-management', id: 'rate-management' },
    { label: 'Manage Data Tables', icon: Table2, path: '/dashboard/admin/system/data-tables', id: 'data-tables' },
    { label: 'Audit Trails', icon: History, path: '/dashboard/audit', id: 'audit-trails' },
    { label: 'Manage Reports', icon: FileBarChart, path: '/dashboard/admin/system/reports', id: 'reports' },
    { label: 'Manage Roles and Permissions', icon: Key, path: '/dashboard/admin/system/roles', id: 'roles' },
    { label: 'Manage Jobs', icon: Clock, path: '/dashboard/admin/system/jobs', id: 'jobs' },
    { label: 'Reporting Calendar', icon: CalendarClock, path: '/dashboard/admin/system/reporting-calendar', id: 'reporting-calendar' },
    { label: 'Configure Maker Checker Tasks', icon: GitMerge, path: '/dashboard/admin/system/maker-checker', id: 'maker-checker' },
    { label: 'Configurations', icon: Settings2, path: '/dashboard/admin/system/configurations', id: 'configurations' },
    { label: 'Account Number Preferences', icon: Hash, path: '/dashboard/admin/system/account-number-prefs', id: 'account-number-prefs' },
    { label: 'Entity to Entity Mapping', icon: Map, path: '/dashboard/admin/system/entity-mapping', id: 'entity-mapping' },
    { label: 'Manage Surveys', icon: ClipboardList, path: '/dashboard/admin/system/surveys', id: 'surveys' },
    { label: 'Two-Factor Authentication', icon: Shield, path: '/dashboard/admin/system/two-factor', id: 'two-factor' },
    { label: 'Sanctions / PEP Screening', icon: ShieldAlert, path: '/dashboard/admin/system/sanctions', id: 'sanctions' },
    { label: 'Service Accounts (Mobile API)', icon: Smartphone, path: '/dashboard/admin/system/service-accounts', id: 'service-accounts' },
    { label: 'Manage External Events', icon: Zap, path: '/dashboard/admin/system/external-events', id: 'external-events' },
    { label: 'Manage Hooks', icon: Webhook, path: '/dashboard/admin/system/hooks', id: 'hooks' },
    { label: 'Credit Life Insurance', icon: HeartHandshake, path: '/dashboard/admin/system/credit-life-insurance', id: 'credit-life-insurance' },
  ];

  return <AdminMenuGrid title="System" breadcrumb={['System', 'Home / System']} items={items} />;
};

export default SystemHubPage;
